import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthStore";
import { AppProvider } from "@/context/AppStore";
import { Shell } from "@/components/Shell";
import Login from "@/pages/Login";
import CommandCenter from "@/pages/CommandCenter";
import CoalIntelligence from "@/pages/CoalIntelligence";
import BoilerTwin from "@/pages/BoilerTwin";
import ProductionIntelligence from "@/pages/ProductionIntelligence";
import AiAdvisor from "@/pages/AiAdvisor";
import Phase2 from "@/pages/Phase2";

// Authenticated shell: provides plant data context (role seeded from the
// logged-in user) and renders the dashboard routes.
function Dashboard() {
  const { user } = useAuth();
  return (
    <AppProvider initialRole={user.role}>
      <Shell>
        <Routes>
          <Route path="/" element={<CommandCenter />} />
          <Route path="/coal" element={<CoalIntelligence />} />
          <Route path="/boiler" element={<BoilerTwin />} />
          <Route path="/production" element={<ProductionIntelligence />} />
          <Route path="/advisor" element={<AiAdvisor />} />
          <Route path="/future" element={<Phase2 />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Shell>
    </AppProvider>
  );
}

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid-lines flex items-center justify-center text-ink-soft">
        <Loader2 size={20} className="animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<RequireAuth><Dashboard /></RequireAuth>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
